export enum RequestCorrespondenceResponseStatus {
	Responded = "RESPONDED",
	NotResponded = "NOT_RESPONDED",
	Pending = "PENDING",
	Authenticated = "AUTHENTICATED",
	AuthenticatedWithReservation = "AUTHENTICATED_WITH_RESERVATION",
	AutoAuthenticated = "AUTO_AUTHENTICATED",
	Accepted = "ACCEPTED",
	Rejected = "REJECTED",
}
